<template>
    <div class="depart-tree-box">
        <el-tree
            v-if="popover === false"
            highlight-current
            draggable
            ref="tree"
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            :class="'department-tree'"
            @node-click="handleTreeNode"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="320"
            trigger="click"
            v-model="visible"
            @after-enter='treeShow'>
             <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText">
            </el-input>
            <el-tree
                v-if="!isRead"
                highlight-current
                :show-checkbox='multiple'
                node-key="id"
                ref="tree"
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :class="'department-tree'"
                :data="treeData"
                :props="defaultProps"
                :filter-node-method="filterNode"
                @node-click="handleTreeNode"
            />
            <div v-if="multiple  && !isRead"  class="buttons">
              <el-button style="float:right;margin-top:10%" type="primary" @click="getCheckedKeys">确定</el-button>
            </div>
             <el-button style="margin-right:20px;float:right;margin-top:10%"  @click="resetChecked">清空</el-button>
             <el-tooltip  slot="reference" :content="selectedContent" effect="light" placement="top">
                  <el-input :disabled="isRead" readonly v-model="popoverTreeLable"></el-input>
              </el-tooltip>
        </el-popover>
    </div>
</template>

<script>
    import { getDepartmentTreeList } from '@/data-model';
    import { isEmpty } from 'lodash';
    import { mapGetters } from 'vuex';
    export default {
        name: 'Department',
        data () {
            return {
                filterText: '',
                idExpandedArr: [],
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: '',
                selectedContent: '',
                multiSelectedNode: {
                    label: '',
                    idExpandedArr: []
                },
                visible: false
            };
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        watch: {
            filterText (val) {
                this.$refs.tree.filter(val);
            }
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            multiple: { // 是否多选
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            isContainSelectHalfNode: { // 是否需要获取半选节点
                type: Boolean,
                default: false
            },
            ifFiltDataSource: { // 是否需要过滤服务端获取到的数据源
                type: Boolean,
                default: false
            },
            listIndex: {
                type: Number,
                default: 0
            },
            currentPK: {
                type: String,
                default: null
            },
            field: {
                type: Object
            }
        },
        created () {
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            });
        },
        methods: {
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async refreshDataSource (rootId) {
                this.treeData = await getDepartmentTreeList(rootId);
            },
            async _getTreeData () {
                let departmentTreeList = [];
                if (this.data) {
                    departmentTreeList = this.data;
                } else {
                    departmentTreeList = await getDepartmentTreeList(this.rootId);
                }
                if (this.ifFiltDataSource) {
                    this.treeData = this.filterInitTree(departmentTreeList, this.rootId);
                } else {
                    this.treeData = departmentTreeList;
                }
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    if (this.selectedNode.ids && this.selectedNode.ids.indexOf(',') !== -1) {
                        this.popoverTreeLable = this.selectedNode.labels;
                        this.selectedContent = this.popoverTreeLable;
                        this.idExpandedArr = [];
                        this.idExpandedArr = this.selectedNode.ids.split(',');
                        this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                        this.multiSelectedNode.label = this.selectedNode.labels;
                        this.multiSelectedNode.idExpandedArr = this.idExpandedArr;
                    } else {
                        this.popoverTreeLable = this.selectedNode.label;
                        this.selectNodeId = this.selectedNode.id;
                        if (this.multiple) {
                            this.popoverTreeLable = this.selectedNode.label;
                            this.selectedContent = this.popoverTreeLable;
                            this.idExpandedArr = [this.selectedNode.id];
                            this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                            this.multiSelectedNode.label = this.selectedNode.label;
                            this.multiSelectedNode.idExpandedArr = this.idExpandedArr;
                        }
                    }
                }
            },
            _refreshSelectedNode (node) {
                if (this.multiple) {
                    if (node && node.value) {
                        this.popoverTreeLable = node.title;
                        this.selectedContent = this.popoverTreeLable;
                        if (node.value.indexOf(',') !== -1) {
                            this.idExpandedArr = [];
                            this.idExpandedArr = node.value.split(',');
                            this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                            this.multiSelectedNode.label = node.title;
                            this.multiSelectedNode.idExpandedArr = this.idExpandedArr;
                        }
                    }
                } else {
                    if (node) {
                        this.popoverTreeLable = node.title;
                        this.selectedContent = this.popoverTreeLable;
                        if (node.value) {
                            this.selectNodeId = Number(node.value);
                        }
                    }
                }
            },
            _refreshTreeData (newData) {
                if (newData) {
                    this.treeData = newData;
                }
            },
            handleTreeNode (data, node, tree) {
                if (this.field && this.field.options.ext2) {
                    let ext2 = this.field.options.ext2;
                    if (ext2) {
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.departChooseSonNode) {
                            if (data.children && data.children.length > 0) { // 父节点，不允许选择
                                this.$message.warning('只允许选择根节点');
                            } else { // 子节点可以被选择
                                if (!this.multiple) {
                                    this.popoverTreeLable = data.label;
                                    this.selectedContent = this.popoverTreeLable;
                                    this.selectNodeId = data.id;
                                    data.currentPK = this.currentPK;
                                    this.$emit('nodeClick', data, node, tree, this.listIndex);
                                    this.visible = false;
                                }
                            }
                        } else {
                            let departMentCanChoose = this.userInfo.departMentCanChoose;// 配置了全局设置
                            if (!departMentCanChoose) {
                                if (data.children && data.children.length > 0) { // 父节点，不允许选择
                                    this.$message.warning('只允许选择根节点');
                                } else { // 子节点可以被选择
                                    if (!this.multiple) {
                                        this.popoverTreeLable = data.label;
                                        this.selectedContent = this.popoverTreeLable;
                                        this.selectNodeId = data.id;
                                        data.currentPK = this.currentPK;
                                        this.$emit('nodeClick', data, node, tree, this.listIndex);
                                        this.visible = false;
                                    }
                                }
                            } else {
                                if (!this.multiple) {
                                    this.popoverTreeLable = data.label;
                                    this.selectedContent = this.popoverTreeLable;
                                    this.selectNodeId = data.id;
                                    data.currentPK = this.currentPK;
                                    this.$emit('nodeClick', data, node, tree, this.listIndex);
                                    this.visible = false;
                                }
                            }
                        }
                    } else {
                        let departMentCanChoose = this.userInfo.departMentCanChoose;// 配置了全局设置
                        if (!departMentCanChoose) {
                            if (data.children && data.children.length > 0) { // 父节点，不允许选择
                                this.$message.warning('只允许选择根节点');
                            } else { // 子节点可以被选择
                                if (!this.multiple) {
                                    this.popoverTreeLable = data.label;
                                    this.selectedContent = this.popoverTreeLable;
                                    this.selectNodeId = data.id;
                                    data.currentPK = this.currentPK;
                                    this.$emit('nodeClick', data, node, tree, this.listIndex);
                                    this.visible = false;
                                }
                            }
                        } else {
                            if (!this.multiple) {
                                this.popoverTreeLable = data.label;
                                this.selectedContent = this.popoverTreeLable;
                                this.selectNodeId = data.id;
                                data.currentPK = this.currentPK;
                                this.$emit('nodeClick', data, node, tree, this.listIndex);
                                this.visible = false;
                            }
                        }
                    }
                } else {
                    let departMentCanChoose = this.userInfo.departMentCanChoose;// 配置了全局设置
                    if (!departMentCanChoose) {
                        if (data.children && data.children.length > 0) { // 父节点，不允许选择
                            this.$message.warning('只允许选择根节点');
                        } else { // 子节点可以被选择
                            if (!this.multiple) {
                                this.popoverTreeLable = data.label;
                                this.selectedContent = this.popoverTreeLable;
                                this.selectNodeId = data.id;
                                data.currentPK = this.currentPK;
                                this.$emit('nodeClick', data, node, tree, this.listIndex);
                                this.visible = false;
                            }
                        }
                    } else {
                        if (!this.multiple) {
                            this.popoverTreeLable = data.label;
                            this.selectedContent = this.popoverTreeLable;
                            this.selectNodeId = data.id;
                            data.currentPK = this.currentPK;
                            this.$emit('nodeClick', data, node, tree, this.listIndex);
                            this.visible = false;
                        }
                    }
                }
            },
            getCheckedKeys () {
                // 采用直接获取节点方法来减少递归消耗
                let checkedNodes = this.$refs.tree.getCheckedNodes();
                let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
                if (this.isContainSelectHalfNode && checkedNodes.length > 0 && halfCheckedNodes.length > 0) {
                    checkedNodes = halfCheckedNodes.concat(checkedNodes);
                }
                let checkedIds = [];
                let checkedNames = [];
                if (checkedNodes.length > 0) {
                    checkedNodes.forEach(item => {
                        checkedIds.push(item.id);
                        checkedNames.push(item.label);
                    });
                }
                let node = {id: '', label: '', selectedIds: '', selectedNames: ''};
                if (checkedIds) {
                    this.popoverTreeLable = checkedNames.join(',');
                    this.selectedContent = this.popoverTreeLable;
                    node.id = checkedIds.join(',');
                    node.selectedIds = checkedIds.join(',');
                    node.label = this.popoverTreeLable;
                    node.selectedNames = this.popoverTreeLable;
                }
                node.currentPK = this.currentPK;
                this.$emit('nodeClick', node);
                this.visible = false;
            },
            resetChecked () {
                this.popoverTreeLable = '';
                this.selectedContent = this.popoverTreeLable;
                let node = {selectedIds: '', selectedNames: ''};
                this.multiSelectedNode = {
                    label: '',
                    idExpandedArr: []
                };
                this.idExpandedArr = [];
                this.$refs.tree.setCheckedKeys(this.idExpandedArr);
                this.$emit('nodeClick', node);
                this.visible = false;
            },
            setTreeStatus () {
                if (this.multiple) {
                    if (!isEmpty(this.multiSelectedNode.idExpandedArr)) {
                        this.idExpandedArr = this.multiSelectedNode.idExpandedArr;
                    }
                } else {
                    this.$nextTick().then(() => {
                        this.$refs.tree.setCurrentKey(this.selectNodeId);
                    });
                }
            },
            treeShow () {
                this.setTreeStatus();
                this.$emit('treeShow');
            },
            filterInitTree (treeList, filterCode) {
                // 过滤出需要展示的数据源
                if (filterCode && filterCode.indexOf(',') > -1) {
                    if (!isEmpty(treeList)) {
                        return treeList.filter(item => {
                            return filterCode.indexOf(item.id) > -1;
                        }).map(item => {
                            item = Object.assign({}, item);
                            if (item.children) {
                                item.children = this.filterInitTree(item.children, filterCode);
                            }
                            return item;
                        });
                    }
                } else {
                    return treeList;
                }
            },
            setCheckedKeys (node) {
                this.popoverTreeLable = '';
                this.$refs.tree.setCheckedKeys(node, true, false);
                let checkedNodes = this.$refs.tree.getCheckedNodes();
                let arr = [];
                if (checkedNodes && checkedNodes.length > 0) {
                    for (let i = 0; i < checkedNodes.length; i++) {
                        let cur = checkedNodes[i];
                        arr.push(cur.label);
                    }
                    this.popoverTreeLable = arr.join(',');
                }
            },
            filterNode (value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            }
        }
    };
</script>
<style lang="less">
    .department-tree{
        max-height: 360px;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Department/Department.vue